const DashboardHeader = () => (
  <div className="dashboard-header">
    <div>
      <h2>Dashboard</h2>
      <p>Overview of job postings, users, and approvals in the portal.</p>
    </div>
    <div className="dashboard-actions">
      <button className="btn-outline">Export</button>
      <button className="btn-primary">+ New Job</button>
    </div>
  </div>
);

export default DashboardHeader;
